import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import { useClient } from '@/api/hooks';

function Grid({ data }: { data?: Record<string, unknown> }) {
  if (!data) return <div className="card text-muted-foreground">No details.</div>;
  return (
    <div className="card grid grid-cols-1 gap-x-8 gap-y-2 md:grid-cols-2 lg:grid-cols-3">
      {Object.entries(data).map(([k, v]) => (
        <div key={k} className="border-b border-border/50 py-1 text-sm">
          <span className="font-medium text-muted-foreground">{k}: </span>
          <span>{String(v ?? '')}</span>
        </div>
      ))}
    </div>
  );
}

export function EngagementAdditional() {
  const { id } = useParams();
  const q = useQuery({
    queryKey: ['engagement-additional', id],
    queryFn: () => api.get<Record<string, unknown>[]>(`/engagements/${id}/additional`),
    enabled: !!id,
  });
  return (
    <div className="space-y-4 p-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-primary">Additional Engagement Details</h2>
        <Link to={`/engagements/${id}`} className="btn-secondary">Back to Engagement</Link>
      </div>
      {q.isFetching ? <div className="card">Loading…</div> : <Grid data={q.data?.[0]} />}
    </div>
  );
}

export function ClientAdditional() {
  const { clientId, subId } = useParams();
  const q = useClient(clientId, subId);
  return (
    <div className="space-y-4 p-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-primary">Additional Client Details</h2>
        <Link to={`/clients/${clientId}/${subId}`} className="btn-secondary">Back to Client</Link>
      </div>
      {q.isFetching ? <div className="card">Loading…</div> : <Grid data={q.data} />}
    </div>
  );
}
